import React from "react";
import { motion } from "framer-motion";
import { SQUAD_STATUSES } from "./squadStats";

/**
 * Stacked status bar: one segment per non-zero status, sized by its share of
 * `byStatus`. `scale` (0–1) shrinks the whole bar so rows stay comparable.
 */
const StatusBar = ({ byStatus, total, height = 8, scale = 1, titled = false }) => (
  <div style={{ width: `${Math.max(scale, 0) * 100}%`, minWidth: total ? 3 : 0 }}>
    <div className="flex w-full overflow-hidden" style={{ height, gap: 2, borderRadius: 3, background: total ? "transparent" : "var(--raise)" }}>
      {total > 0 &&
        SQUAD_STATUSES.filter((s) => byStatus[s.value] > 0).map((s) => (
          <motion.div
            key={s.value}
            initial={{ width: 0 }}
            animate={{ width: `${(byStatus[s.value] / total) * 100}%` }}
            transition={{ duration: 0.9, ease: [0.2, 0.7, 0.2, 1] }}
            title={titled ? `${s.label}: ${byStatus[s.value]}` : undefined}
            style={{ background: s.color, minWidth: 3, borderRadius: 3, height: "100%" }}
          />
        ))}
    </div>
  </div>
);

export default StatusBar;
